

export const categories = [
    { id: 1, type: 'Music'},
    { id: 2, type: 'Tech'},
    { id: 3, type: 'Fashion'},
    { id: 4, type: 'Sports'},
    { id: 5, type: 'Movies'},
]